import React, { useState, useEffect } from 'react';
import { Row, Container, Col } from "react-bootstrap";
import { useLocation } from 'react-router-dom';
import AccessibilityPolicy from '../Disclosure/AccessibilityPolicy';
import PrivacyPolicy from '../Disclosure/PrivacyPolicy';
import TermsAndConditions from '../Disclosure/TermsAndConditions';
import StateDisclosure from '../Disclosure/StateDisclosure';
import SupportModal from '../Layout/SupportModal';
import FooterModalPopup from './FooterModalPopup';
import './Footer.scss';

const links = {
  Terms: "TermsAndConditions",
  Security: "SecurityAndPrivacyPolicy",
  Accessibility: "AccessibilityPolicy",
  Contact: "ContactUs",
  StateLicense: "StateLicenseDisclosure",
};

const sentryBuildNumber = process.env.VITE_SENTRY_BUILD_NUMBER;

export default function Footer({ expanded, isSignWithoutAuth }) {
  const location = useLocation();
  const year = new Date().getFullYear();
  const isLandingPage = location.pathname.toLowerCase().indexOf('landing') > -1;

  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [accountId, setAccountId] = useState('');
  const [disclaimer, setDisclaimer] = useState('');
  const [disclaimerBelow, setDisclaimerBelow] = useState(false);
  const [renderComponent, setRenderComponent] = useState(null);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const onButtonClick = (linkName) => {
    if (linkName === links.Contact) {
      handleOpenModal();
    } else if (linkName === links.Terms) {
      setRenderComponent(<TermsAndConditions />);
      setInfoDialogOpen(true);
    } else if (linkName === links.Security) {
      setRenderComponent(<PrivacyPolicy />);
      setInfoDialogOpen(true);
    } else if (linkName === links.Accessibility) {
      setRenderComponent(<AccessibilityPolicy />);
      setInfoDialogOpen(true);
    } else if (linkName === links.StateLicense) {
      setRenderComponent(<StateDisclosure />);
      setInfoDialogOpen(true);
    }
  };

  return (
    <footer className={`${isSignWithoutAuth && 'ms-0'} footer py-3 flex-fill ${expanded ? "sidebar-open" : "sidebar-close"}`}>
      <Container fluid>
        <Col lg={12}>
          <Row className="justify-content-center"><strong>Powered by</strong></Row>
          <Row className="justify-content-center">
            <img src="/logos/covr-logo.svg" alt="Covr Logo" />
          </Row>
          <Row className="justify-content-center covr">Covr Financial Technologies</Row>
          <Row className="justify-content-center">Hartford. Boise. Colorado Springs.</Row>
          {!isLandingPage && <Row className="justify-content-center">Copyright &copy; {year}</Row>}
        </Col>

        <FooterModalPopup
          open={infoDialogOpen}
          onDialogClose={() => {
            setInfoDialogOpen(false);
          }}
          component={renderComponent}
        />

        <SupportModal open={modalOpen} handleClose={handleCloseModal} />

      </Container>
    </footer>
  );
}
